module.exports = __webpack_public_path__ + "0c638bb945e5f93ed0dbf79ff37c28a9.jpg";